// extracted by mini-css-extract-plugin
export var container = "_cr-0";
export var infoIcon = "_cr-2";
export var internalLabel = "_cr-3";
export var titleRowCol = "_cr-1";